export default "/Contraster.714fce97-829cfe.woff2";